module.exports = __webpack_public_path__ + "EFE8A526FA5D687D977B74FD8880AAC2aboutUs1.3c2ba5c3.png";